import { ESRI } from '@rsos/constants/mapProviders';

/**
 * Updates and returns the given circle instance
 * @param {Object} mapObject - map object
 * @param {Instance} circle - instance of the circle
 * @param {Object} options - options for the circle
 * @param {Object} options.symbolOptions - options for changing the symbol property of the circle
 */
const updateCircle = ({ mapObject, circle, options = {} }) => {
  switch (mapObject.mapProvider) {
    case ESRI: {
      if (options.symbolOptions) {
        circle.symbol = options.symbolOptions;
      }
      break;
    }
    default:
      return null;
  }
  return circle;
};

export default updateCircle;
